<template>
    <div>
        <SortableList title="Tipos de Produtos"
            ref="organizer"
            @add="() => modalFrmAddEdit.visible = true"
            @selected="setSelected"
            @totalItems="(v) => totalItems = v"
            @saveEditing="(item, desc) => saveEditing(item, desc)"
            @disableItem="disableItem"
            @edit="editProductType"
            :saveOrderPromise="saveOrder"
            :customFilter="filterPredicate"
            allowEdit
            :disableAdd="!selectedMenuId"
            :busy.sync="busy"/>

        <CreateNewProductType
            :key="key"
            :productType="modalFrmAddEdit.productType"
            :visible.sync="modalFrmAddEdit.visible"
            :menuID="selectedMenuId"
            :lastOrderNumber="totalItems"/>

    </div>
</template>

<script>
    import SortableList from './SortableList';
    import CreateNewProductType from '@/components/productType/CreateNewProductType';
    
    import organizerMixin from './organizerMixin';

    export default {
        mixins: [organizerMixin('productType')],
        components: {
            SortableList,
            CreateNewProductType
        },
        props: {
            selectedMenuId: String
        },

        watch: {
            selectedMenuId (val) {
                this.$emit('selected', null);
                this.filterPredicate = (doc) => doc.menu === val && doc.active;
            },
            'modalFrmAddEdit.visible' (val) {
                if (!val)
                    this.modalFrmAddEdit.productType = null;
            }
        },
        data() {
            return {
                totalItems: 0,
                filterPredicate: () => false, // do not display anything util have a filter
                modalFrmAddEdit: {
                    visible: false,
                    productType: null
                }
            }
        },
        computed: {
            key () {
                return this.modalFrmAddEdit.productType ?
                    this.modalFrmAddEdit.productType.id : this.selectedMenuId;
            }
        },
        methods: {
            setSelected (item) {
                this.$emit('selected', item);
            },
            editProductType (productType) {
                this.modalFrmAddEdit.visible = true;
                this.modalFrmAddEdit.productType = productType;
            }
        },
        async mounted () {
            await this.get(); // inside mixin
        },
    }
</script>

<style lang="scss" scoped>

</style>